export const createCarChargingRepository = (appFetch) => {
    return {
        auth(body, options) {
            return appFetch.post('/api/security/auth', body, options);
        },
        confirmAuth(code, params = {}) {
            return appFetch.get(`/api/security/confirm-code/${code}`, {params});
        },
        availableSlots(date, params = {}) {
            return appFetch.get(`/api/time-slot/schedule/${date}`, {params});
        },
        booking(body, options = {}) {
            return appFetch.post('/api/time-slot', body, options);
        },
    };
};
